import React, { useState } from "react";
import { Grid, CircularProgress, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  operationsOptions,
  portOperationsOptions,
  getVesselVesselOperationOptions,
} from "../../constants";
import { handleKeyDown } from "../../common/common";

function AddOperationsModal(props) {
  const {
    selectedOperation = {},
    delayPortsSearch = () => { },
    portOptions = [],
    portLoading = false,
    onClickCalculateDistance = () => { },
    onSelectPortsOfOperation = () => { },
    initialAddOperation = {},
    setInitialAddOperation = () => { },
    onAddOperationByModal = () => { },
    isOperationTab = false,
    vesselVesselOperationList = null,
  } = props;

  let newPortOptions = [...portOptions];
  let selectedPort = { label: "", value: "" };
  if (initialAddOperation.port) {
    // newPortOptions = [...portOptions, { label: initialAddOperation.port, value: initialAddOperation.port }]
    selectedPort = {
      label: initialAddOperation.port,
      value: initialAddOperation.port,
      lat: initialAddOperation?.lat,
      lng: initialAddOperation?.lng,
    };
  }
  const baseOptions = isOperationTab ? operationsOptions : portOperationsOptions;
  // vessel-vessel passes its itinerary so Delivery-out / Redelivery-in disable once one exists
  const optionsToRender = vesselVesselOperationList
    ? getVesselVesselOperationOptions(baseOptions, vesselVesselOperationList)
    : baseOptions;
  return (
    <div className="add-operations-modal-container">
      <style>{`
        .add-operations-modal-container {
          width: 100%;
          padding: 4px 0;
        }
        .add-operations-modal-container .add-operation-label {
          font-size: 11px;
          font-weight: 500;
          color: #334155;
          margin-bottom: 4px;
        }
        .add-operations-modal-container .add-operation-modal-select {
          width: 100%;
          height: 26px !important;
          border-radius: 2px !important;
          border: 1px solid #cbd5e1 !important;
          font-size: 11px !important;
          font-weight: 500 !important;
          padding: 0 6px !important;
          color: #000000 !important;
          background-color: #ffffff !important;
          box-sizing: border-box !important;
          outline: none !important;
        }
        .add-operations-modal-container .add-operation-modal-select:focus {
          border-color: #d97706 !important;
          outline: 1.5px solid #d97706 !important;
          outline-offset: -1.5px !important;
        }
        .add-operations-modal-container .MuiAutocomplete-root {
          width: 100%;
        }
        .add-operations-modal-container .MuiOutlinedInput-root {
          height: 26px !important;
          min-height: 26px !important;
          padding: 0 26px 0 6px !important;
          font-size: 11px !important;
          border-radius: 2px !important;
          background-color: #ffffff !important;
        }
        .add-operations-modal-container .MuiOutlinedInput-notchedOutline {
          border-color: #cbd5e1 !important;
        }
        .add-operations-modal-container .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
          border-color: #94a3b8 !important;
        }
        .add-operations-modal-container .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
          border-color: #d97706 !important;
          border-width: 1.5px !important;
        }
        .add-operations-modal-container .MuiOutlinedInput-input {
          padding: 0 !important;
          font-size: 11px !important;
          font-weight: 500 !important;
          height: 26px !important;
          line-height: 26px !important;
          box-sizing: border-box !important;
          color: #000000 !important;
        }
        .add-operations-modal-container .MuiAutocomplete-endAdornment {
          top: 50% !important;
          transform: translateY(-50%) !important;
          right: 4px !important;
        }
        .add-operations-modal-container .MuiIconButton-root {
          padding: 2px !important;
        }
        .add-operations-modal-container .MuiSvgIcon-root {
          font-size: 16px !important;
          color: #475569 !important;
        }
        .add-operations-modal-container .add-operation-input {
          width: 100% !important;
          height: 26px !important;
          border-radius: 2px !important;
          border: 1px solid #cbd5e1 !important;
          padding: 0 6px !important;
          font-size: 11px !important;
          font-weight: 500 !important;
          color: #000000 !important;
          background-color: #ffffff !important;
          box-sizing: border-box !important;
          outline: none !important;
        }
        .add-operations-modal-container .add-operation-input:focus {
          border-color: #d97706 !important;
          outline: 1.5px solid #d97706 !important;
          outline-offset: -1.5px !important;
        }
        .add-operations-modal-container .add-operation-input::-webkit-outer-spin-button,
        .add-operations-modal-container .add-operation-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        .add-operations-modal-container .add-operation-input[type="number"] {
          -moz-appearance: textfield;
        }
        .add-operations-modal-container .calculate-port-distance-btn {
          margin: 12px auto 0 auto !important;
          height: 25px !important;
          line-height: 25px !important;
          padding: 0 14px !important;
          font-size: 11px !important;
          font-weight: 500 !important;
          border-radius: 2px !important;
          background-color: #313C4C !important;
          color: #ffffff !important;
          border: none !important;
          cursor: pointer !important;
          outline: none !important;
          display: block !important;
          transition: background-color 0.15s ease !important;
        }
        .add-operations-modal-container .calculate-port-distance-btn:hover {
          background-color: #1e293b !important;
        }
        .compact-port-popper .MuiAutocomplete-paper {
          margin-top: 2px !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1) !important;
          border-radius: 2px !important;
        }
        .compact-port-popper .MuiAutocomplete-option {
          font-size: 11px !important;
          min-height: 24px !important;
          padding: 3px 8px !important;
          color: #000000 !important;
          font-weight: 500 !important;
        }
      `}</style>
      <Grid container>
        <Grid item xs={12}>
          <p className="add-operation-label">Select Operation</p>
          <select
            value={initialAddOperation.operation || ""}
            name="operation"
            onChange={(e) =>
              setInitialAddOperation({
                ...initialAddOperation,
                operation: e.target.value,
              })
            }
            className="add-operation-modal-select"
          >
            {optionsToRender.map((option, key) => (
              <option key={key} value={option.value} disabled={option.isDisabled}>
                {option.label}
              </option>
            ))}
          </select>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 10 }}>
          <p className="add-operation-label">Select Port</p>
          <Autocomplete
            classes={{ popper: "compact-port-popper" }}
            options={
              portLoading || newPortOptions.length === 0 ? [] : newPortOptions
            }
            value={selectedPort}
            disableClearable
            getOptionLabel={(option) => option.label || ""}
            onChange={(e, value) =>
              setInitialAddOperation({
                ...initialAddOperation,
                port: value.value,
                lat: value?.lat,
                lng: value?.lng,
              })
            }
            getOptionSelected={(option, value) => option.value === value.value}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Search port"
                value={selectedPort.label}
                onChange={(e) =>
                  delayPortsSearch(initialAddOperation, e.target.value, true)
                }
                size="small"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {portLoading ? (
                        <CircularProgress color="inherit" size={12} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} style={{ marginTop: 10 }}>
          <p className="add-operation-label">Port Exp</p>
          <input
            onKeyDown={handleKeyDown}
            type="number"
            className="add-operation-input"
            value={initialAddOperation.portExp}
            onChange={(e) =>
              setInitialAddOperation({
                ...initialAddOperation,
                portExp: Number(e.target.value),
              })
            }
          />
        </Grid>

        <Grid item xs={12} style={{ marginTop: 10 }}>
          <p className="add-operation-label">Extra Days</p>
          <input
            onKeyDown={handleKeyDown}
            type="number"
            className="add-operation-input"
            value={initialAddOperation.extraDays}
            onChange={(e) =>
              setInitialAddOperation({
                ...initialAddOperation,
                extraDays: Number(e.target.value),
              })
            }
          />
        </Grid>

        <Grid item xs={12}>
          <button
            className="calculate-port-distance-btn"
            onClick={onAddOperationByModal}
          >
            Add Operation
          </button>
        </Grid>
      </Grid>
    </div>
  );
}

export default AddOperationsModal;
